import React, { useState, useEffect, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import DefaultLayout from '../layouts/DefaultLayout';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router';
import { Col, Container, Image, Row } from 'react-bootstrap';
import clsx from 'clsx';
import Iframe from 'react-iframe';
import Text from '../components/Text';


export interface ContactUsProps {
  history: any
}

const ContactUs: React.FC<ContactUsProps> = ({ history }) => {
  const classes = useStyles();
  return (
    <>
      <Helmet>
        <title>twigBIG</title>
      </Helmet>

      <DefaultLayout history={history}>
        <Container className={clsx(classes.container, 'mt-5')} fluid>
          <Row>
            <Col className={classes.containerInfo} xs={12}>
              {/* <Image width="300px" style={{"marginBottom": "30px"}} src={`${process.env.PUBLIC_URL}/assets/img/twigLogo.svg`}>
              </Image> */}

              <Text as="p">
                Address: <Text as="span" bold>UAE, Dubai, Dubai Knowledge Park, In5 Tech</Text>



              </Text>
              <Text as="p">
                Phone: <Text as="span" bold>+971 588 533 423</Text>
              </Text>
              <Text as="p">
              <br></br>
                For any support/return/refund queries, please emails us on support@twigBIG.com
              </Text>
              <Text as="p">
                To apply for a job, please send your resume to jobs@twigBIG.com
              </Text>
              <Text as="p">
                For general queries, please email us on admin@twigbig.com
              </Text>
            </Col>

            <Col xs={12}>
              <iframe id="iframe"

                className={classes.iframe} src="https://share.hsforms.com/16m2pKgpMQiaRYuDtBA_FXQ4mjyw"></iframe>
            </Col>
          </Row>
        </Container>
      </DefaultLayout>
    </>
  );
};

const useStyles = createUseStyles({
  container: {
    maxWidth: '85vw',
  },

  iframe: {
    width: "100%",
    height: "800px",
    border: "0px"
  },
  containerInfo: {
    width: "100%",
    paddingLeft: "calc((100% - 800px) /2)"
  },
  '@media (max-width: 768px)': {
    container: {
      maxWidth: '850vw',
    },
    containerInfo: {
      paddingLeft: "15px"
    }
  }
});

export default ContactUs;
